import api from '../lib/api';

const articlesService = {
  getArticles: (params) => api.get('/articles', { params }),
  getArticle: (id) => api.get(`/articles/${id}`),
  getFeaturedArticles: () => api.get('/articles/featured'),
  getTrendingArticles: () => api.get('/articles/trending'),
  createArticle: (data) => api.post('/articles', data),
  updateArticle: (id, data) => api.put(`/articles/${id}`, data),
  deleteArticle: (id) => api.delete(`/articles/${id}`),
  publishArticle: (id) => api.post(`/articles/${id}/publish`),
  unpublishArticle: (id) => api.post(`/articles/${id}/unpublish`),
  getMyDrafts: () => api.get('/articles/my/drafts'),
  getMyPublished: () => api.get('/articles/my/published'),
  getMyPending: () => api.get('/articles/my/pending'),
  getMyBookmarks: () => api.get('/users/bookmarks'),
  getMyBookmarkIds: () => api.get('/users/bookmarks/ids'),
};

export default articlesService;
